exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2x3N25Tu3aY5fgzYFNrUXw {\n    border: none;\n    background-color: transparent;\n    outline: none;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    cursor: pointer;\n    padding: 0;\n}\n", ""]);

// exports
exports.locals = {
	"iconButton": "_2x3N25Tu3aY5fgzYFNrUXw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/styles/buttons.css
// module id = 316
// module chunks = 23